import React from "react";
import "./Hero.scss";
import { FiArrowDown } from "react-icons/fi";

function Hero() {
  return (
    <section className="hero" id="home">
      <div className="container hero-inner">
        <h1 className="hero-name">
          YUN
          <br />
          SUNG BIN
        </h1>

        <p className="hero-role">Web Developer</p>
        <p className="hero-tagline">
          구조 설계부터 배포까지, 끝까지 굴러가게 만드는 개발자
        </p>
      </div>

      <a className="hero-scroll" href="#profile" aria-label="아래로 스크롤">
        <FiArrowDown />
      </a>
    </section>
  );
}

export default Hero;
